import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { BulkSupplierContactsImporter } from '@/areas/suppliers/Suppliers/BulkSupplierContactsImporterPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/suppliers/supplier-contacts/importer')({
    staticData: {
        access: { permissions: ['view:supplier', 'create:supplier'] },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <BulkSupplierContactsImporter />;
}
